"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyMultipleOptionInput',
  props: {
    value: Array
  },
  methods: {
    handleAdd() {
      this.value.push({
        value: '',
        label: ''
      });
    },
    handleRemove(index) {
      this.value.splice(index, 1);
    },
    handleValueChange(item) {
      item.value = item.value.trim();
    },
    handleLabelChange(item) {
      item.label = item.label.trim();
    }
  }
};